module.exports = __webpack_public_path__ + "img/انتزاعی.e14a164d.png";